import { useEffect, useState } from "react";
import { Dimensions } from "react-native";

export function useResponsive() {
  const [screenSize, setScreenSize] = useState<"small" | "medium" | "large">(
    () => {
      const width = Dimensions.get("window").width;
      const screenSize =
        0 < width && width < 640
          ? "small"
          : 640 <= width && width < 1024
            ? "medium"
            : "large";

      return screenSize;
    },
  );

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", (event) => {
      const width = event.window.width;

      const newScreenSize =
        0 < width && width < 640
          ? "small"
          : 640 <= width && width < 1024
            ? "medium"
            : "large";
      if (screenSize !== newScreenSize) {
        setScreenSize(newScreenSize);
      }
    });

    return () => {
      subscription.remove();
    };
  }, [screenSize]);

  return function r<A, B, C>(mobile: A, tablet: B, desktop: C): A | B | C {
    switch (screenSize) {
      case "small":
        return mobile;
      case "medium":
        return tablet;
      case "large":
        return desktop;
    }
  };
}
